import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Infinity as InfinityIcon, Star, ArrowRight } from 'lucide-react';
import { goToCheckout } from '../utils/checkout';
export function Hero() {
  return <section className="relative pt-28 pb-20 md:pt-36 md:pb-28 px-4 overflow-hidden" data-id="element-74">
      {/* Background glow */}
      <div className="absolute inset-0 z-0" data-id="element-75">
        <img src="https://images.unsplash.com/photo-1566492031773-4f4e44671857?auto=format&fit=crop&w=1920&q=80" alt="" aria-hidden="true" className="w-full h-full object-cover opacity-20" data-id="element-76" />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-dark/85 via-brand-dark/92 to-brand-dark" data-id="element-77" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10 grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-78">
        {/* Copy column */}
        <div className="text-center lg:text-left order-2 lg:order-1" data-id="element-79">
          <motion.span className="inline-block text-brand-orange font-bold tracking-widest text-xs md:text-sm uppercase mb-6 border border-brand-orange/30 bg-brand-orange/10 px-4 py-2 rounded-full" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-80">
            Para el hombre 40+ que se niega a conformarse
          </motion.span>

          <motion.h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-[1.05] uppercase" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.05
        }} data-id="element-81">
            Recupera la Energía, el Enfoque y la Libido de tus 25 Años{' '}
            <span className="text-brand-orange" data-id="element-82">en Solo 21 Días.</span>
          </motion.h1>

          <motion.p className="text-lg md:text-xl text-brand-text mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed font-medium" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-83">
            El reinicio neuro-hormonal que despierta de nuevo tu fuego
            competitivo, borra la niebla mental y te devuelve la versión de ti
            mismo que creías perdida.{' '}
            <span className="text-brand-muted" data-id="element-84">
              Sin fármacos, sin TRT y sin vivir en el gimnasio.
            </span>
          </motion.p>

          {/* Social proof cue */}
          <motion.div className="flex items-center justify-center lg:justify-start gap-3 mb-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.15
        }} data-id="element-85">
            <div className="flex" data-id="element-86">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-orange text-brand-orange" data-id="element-87" />)}
            </div>
            <span className="text-brand-muted text-sm font-medium" data-id="element-88">
              +500 hombres ya iniciaron su reinicio
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-col items-center lg:items-start" data-id="element-89">
            <button onClick={goToCheckout} className="group bg-brand-orange hover:bg-[#ff6a26] text-white font-display font-bold text-xl md:text-2xl py-5 px-10 w-full sm:w-auto rounded-sm transition-all transform hover:scale-105 shadow-[0_0_25px_rgba(255,81,0,0.45)] uppercase tracking-wide flex items-center justify-center gap-3" data-id="element-90">
              Empezar mi reinicio hoy
              <ArrowRight className="w-6 h-6 transition-transform group-hover:translate-x-1" data-id="element-91" />
            </button>
            <span className="text-brand-muted text-sm mt-3" data-id="element-92">
              Acceso inmediato por solo{' '}
              <span className="text-white font-bold" data-id="element-93">$6.36</span> — un solo
              pago.
            </span>

            <div className="flex flex-wrap justify-center lg:justify-start gap-4 md:gap-6 mt-6 text-sm text-brand-muted font-medium" data-id="element-94">
              <div className="flex items-center gap-1.5" data-id="element-95">
                <CreditCard className="w-4 h-4 text-brand-orange" data-id="element-96" />
                <span data-id="element-97">Pago único</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-98">
                <InfinityIcon className="w-4 h-4 text-brand-orange" data-id="element-99" />
                <span data-id="element-100">Acceso de por vida</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-101">
                <ShieldCheck className="w-4 h-4 text-brand-orange" data-id="element-102" />
                <span data-id="element-103">Garantía de 7 días</span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Product image column */}
        <motion.div className="order-1 lg:order-2 flex justify-center" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-104">
          <img src="https://cdn.magicpatterns.com/uploads/btVEywnEErmj7scvJtDTSp/ChatGPT_Image_13_jun_2026,_19_53_13.png" alt="Libro El Protocolo Alpha" className="w-full max-w-xs md:max-w-sm h-auto object-contain drop-shadow-[0_0_60px_rgba(255,81,0,0.4)]" data-id="element-105" />
        </motion.div>
      </div>
    </section>;
}